import isToday from 'date-fns/isToday';
import format from 'date-fns/format';
import formatRelative from 'date-fns/formatRelative';
import isYesterday from 'date-fns/isYesterday';
var DEFAULT_URL_PREFIX = 'https://static.sendbird.com/sample/cover/cover_';

var getOpenChannelAvatar = function (channel) {
  if (channel === null || channel === void 0 ? void 0 : channel.coverUrl) {
    return channel.coverUrl;
  }
};
var getChannelAvatarSource = function (channel, currentUserId) {
    console.log("channel",channel)
    console.log("currentUserId",currentUserId)
  if (channel === null || channel === void 0 ? void 0 : channel.coverUrl) {
    if (!new RegExp("^".concat(DEFAULT_URL_PREFIX)).test(channel.coverUrl)) {
      console.log("channel.coverUrl")
      return channel.coverUrl;
    }
  }
  return ((channel === null || channel === void 0 ? void 0 : channel.members) || []).filter(function (member) {
    // console.log("member.userId !== currentUserId;")
    return member.userId !== currentUserId;
  }).map(function (_a) {
    var profileUrl = _a.profileUrl;
    console.log("_a",_a)
    const text = _a.userId ? _a.userId.substring(0, 2).toUpperCase() : ''
    return text;
  });
};
var generateDefaultAvatar = function (channel) {
  if (channel === null || channel === void 0 ? void 0 : channel.coverUrl) {
    if (new RegExp("^".concat(DEFAULT_URL_PREFIX)).test(channel.coverUrl)) {
      return true;
    }

    return false;
  }

  return true;
};


export const getLastMessageCreatedAt = (channel, locale) => {
  const createdAt = channel?.lastMessage?.createdAt;
  const optionalParam = locale ? { locale } : null;
  if (!createdAt) {
    return '';
  }
  if (isToday(createdAt)) {
    return format(createdAt, 'p', optionalParam);
  }
  if (isYesterday(createdAt)) {
    return formatRelative(createdAt, new Date(), optionalParam);
  }
  return format(createdAt, 'MMM dd', optionalParam);
};

export const getTotalMembers = (channel) => (
  channel?.memberCount
    ? channel.memberCount
    : 0
);

export const getChannelUnreadMessageCount = (channel) => (
  channel?.unreadMessageCount
    ? channel.unreadMessageCount
    : 0
);


export { getChannelAvatarSource as a, getOpenChannelAvatar as b, generateDefaultAvatar as g };
//# sourceMappingURL=utils-2252e970.js.map
